import styled from 'styled-components';

export const MenuStyle = styled.div`
  margin-right: auto;
  z-index: 99;

  &.absolute-menu {
    .burger {
      position: fixed;
      top: 15px;
      z-index: 4;
      left: 115px;
    }
  }

  .burger {
    width: 20px;
    cursor: pointer;
  }

  .menu-background {
    opacity: 0;
    width: 100%;
    height: 100vh;
    position: fixed;
    max-width: 476px;
    margin: 0 auto;
    top: 0px;
    left: 50%;
    z-index: 10;
    background-color: ${(props) => props.theme.primary.primary70};
    transform: translateX(-150%);
    transition: all 0.3s;
    z-index: 11;
    &.active {
      opacity: 1;
      transform: translateX(-50%);
    }
  }

  .menu-container {
    display: flex;
    flex-direction: column;
    visibility: hidden;
    opacity: 0;
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;

    background-color: transparent;
    color: #ffffff;
    transform: translateX(-150%);
    transition: opacity 0.3s;

    &.active {
      visibility: visible;
      opacity: 1;
      transform: translateX(0);
    }
  }

  .close-button {
    padding: 22px 16px;
    &__icon {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: auto;
    }
  }

  .nav-links {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: auto;
    color: white;
    padding: 22px 16px 82px;
    overflow-y: auto;

    &-bottom {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &__item {
        border: none;
        outline: none;
        padding: none;
        background-color: transparent;
        color: inherit;
        cursor: pointer;
        margin-bottom: 12px;
      }
    }
  }
`;
